import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { getLabelApi } from 'root/services/disk';
import { Form, Input, Tooltip, Checkbox } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form/Form';
import Icon from 'root/components/Icon';
import messages from '../messages';
import styles from './index.less';
interface FCFormProps extends FormComponentProps {
  data: any;
  inputValue: string;
  setInputValue: any;
}

const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 18 },
  },
};

const SetForm = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const { form, data, setInputValue } = props;
  const { getFieldDecorator } = form;
  const [labelOptions, setLabelOptions] = useState([]);
  const { cluster, isSuposInstalled } = useSelector((state: reducerStates) => state.envManage);

  useImperativeHandle(ref, () => ({
    form,
  }));

  // 自定义服务器地址校验
  const checkValue = async (rule: any, value: string, callback: () => void) => {
    if (!value) return callback();
    const flagIp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
    if (flagIp.test(value)) {
      return callback();
    } else {
      throw new Error(intl.formatMessage(messages.serverAddressRule));
    }
  };

  useEffect(() => {
    getLabelApi().then((res) => {
      const { data } = res;
      setLabelOptions(labelOptions.concat(data));
    });
  }, []);

  return (
    <Form {...formItemLayout}>
      <Form.Item label={intl.formatMessage(messages.customHostName)}>
        {getFieldDecorator('name', {
          initialValue: data?.name,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.customHostNameRequired),
            },
          ],
        })(<Input maxLength={64} />)}
      </Form.Item>

      <Form.Item
        label={
          <Tooltip title={intl.formatMessage(messages.hostIpTip)}>
            <span>{intl.formatMessage(messages.serverAddress)}</span>
            <Icon type="help16" />
          </Tooltip>
        }
      >
        {getFieldDecorator('ip', {
          initialValue: data?.ip,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.serverAddressRequired),
            },
            {
              validator: checkValue,
            },
          ],
        })(<Input maxLength={64} disabled={cluster && isSuposInstalled} />)}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.userName)}>
        {getFieldDecorator('user', {
          initialValue: 'root', // 默认为root
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.userNameRequired),
            },
          ],
        })(<Input disabled />)}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.pwd)}>
        {getFieldDecorator('password', {
          initialValue: 'defaultPassword',
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.pwdRequire),
            },
          ],
        })(<Input.Password autoComplete="new-password" maxLength={64} className={styles.password} />)}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.sshPort)}>
        {getFieldDecorator('sshPort', {
          initialValue: data?.sshPort,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.sshPortRequire),
            },
            {
              pattern: new RegExp(/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/),
              message: intl.formatMessage(messages.sshPortCheck),
            },
          ],
        })(<Input maxLength={64} />)}
      </Form.Item>

      {cluster ? (
        <Form.Item label={intl.formatMessage(messages.tag)}>
          {getFieldDecorator('labels', {
            initialValue: data.labels,
          })(
            <Checkbox.Group style={{ width: '100%' }}>
              {labelOptions.map((item: any) => (
                <Checkbox key={item.id} value={item.label || ''}>
                  <span className={styles.checkboxItme} title={item.label}>
                    {item.label}
                  </span>
                </Checkbox>
              ))}
              <div>
                <Checkbox value={0}>
                  <Input
                    style={{ width: 80, height: 24 }}
                    onChange={(e: any) => setInputValue(e.target.value)}
                    size="small"
                    placeholder="自定义"
                  />
                </Checkbox>
              </div>
            </Checkbox.Group>,
          )}
        </Form.Item>
      ) : null}
    </Form>
  );
});

export default Form.create()(SetForm);
